"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.CustomFooterContent = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _contextProps = require("../../../propTypes/contextProps");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/* eslint-disable react/prop-types */

const CustomFooterContent = _ref => {
  let {
    footerSections
  } = _ref;
  const CustomFooterLinks = _ref2 => {
    let {
      customFooterLinks
    } = _ref2;
    return /*#__PURE__*/_react.default.createElement("ul", {
      className: "customFooterLinks"
    }, customFooterLinks.map(link => /*#__PURE__*/_react.default.createElement("li", {
      key: link.label
    }, /*#__PURE__*/_react.default.createElement("a", {
      target: "_blank",
      rel: "noreferrer",
      href: link.url
    }, link.label))));
  };
  const CustomFooterPiece = _ref3 => {
    let {
      section
    } = _ref3;
    return /*#__PURE__*/_react.default.createElement("section", {
      className: "customFooterPiece"
    }, section.heading && /*#__PURE__*/_react.default.createElement("h3", null, section.heading), section.content, section.links && /*#__PURE__*/_react.default.createElement(CustomFooterLinks, {
      customFooterLinks: section.links
    }));
  };
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "customFooterContent"
  }, footerSections.map((section, index) =>
  /*#__PURE__*/
  // eslint-disable-next-line react/no-array-index-key
  _react.default.createElement(CustomFooterPiece, {
    key: "".concat(section.heading, "_").concat(index),
    section: section
  })));
};
exports.CustomFooterContent = CustomFooterContent;
CustomFooterContent.propTypes = {
  footerSections: _propTypes.default.arrayOf(_contextProps.FooterSectionProps)
};
var _default = exports.default = CustomFooterContent;